<template>
  <div>
    <ServerError v-if="ServerError" />
    <vue-element-loading :active="appLoading" :is-full-screen="false" />
    <b-row>
      <b-col cols="12" lg="12">
        <b-card no-header>
          <template slot="header">Add New Mammal</template>
          <b-row class="justify-content-md-center">
            <b-col cols="12" md="9">
              <b-row class="justify-content-md-center">
                <b-col cols="12" md="6">
                  <!-- <div :class="{error: validation.hasError('lastname')}"> -->
                  <b-form-group label="Common Name">
                    <b-form-input
                      v-model="commonname"
                      type="text"
                      id="commonname"
                      placeholder="Common Name"
                    ></b-form-input>
                    <!-- <template slot="description" v-if="validation.firstError('firstname')">
                        <span style="color:red;">{{validation.firstError('firstname')}}</span>
                    </template>-->
                  </b-form-group>
                  <!-- </div> -->
                </b-col>
                <b-col cols="12" md="6">
                  <!-- <div :class="{error: validation.hasError('firstname')}"> -->
                  <b-form-group label="Family">
                    <b-form-input
                      v-model="family"
                      type="text"
                      id="family"
                      placeholder="Family"
                    ></b-form-input>
                    <!-- <template slot="description" v-if="validation.firstError('firstname')">
                        <span style="color:red;">{{validation.firstError('firstname')}}</span>
                    </template>-->
                  </b-form-group>
                  <!-- </div> -->
                </b-col>
                <b-col cols="12" md="6">
                  <!-- <div :class="{error: validation.hasError('middlename')}"> -->
                  <b-form-group label="Latin Name ">
                    <b-form-input
                      v-model="latinname"
                      type="text"
                      id="latinname"
                      placeholder="Latin Name"
                    ></b-form-input>
                    <!-- <template slot="description" v-if="validation.firstError('middlename')">
                        <span style="color:red;">{{validation.firstError('middlename')}}</span>
                    </template>-->
                  </b-form-group>
                  <!-- </div> -->
                </b-col>

                <b-col cols="12" md="6">
                  <!-- <div :class="{error: validation.hasError('middlename')}"> -->
                  <b-form-group label="Local Name">
                    <b-form-input
                      v-model="localname"
                      type="text"
                      id="localname"
                      placeholder="Local Name"
                    ></b-form-input>
                    <!-- <template slot="description" v-if="validation.firstError('middlename')">
                        <span style="color:red;">{{validation.firstError('middlename')}}</span>
                    </template>-->
                  </b-form-group>
                  <!-- </div> -->
                </b-col>

                <b-col cols="12" md="12">
                  <!-- <div :class="{error: validation.hasError('lastknown')}"> -->
                  <b-form-group label="Description">
                    <b-form-textarea
                      id="description"
                      v-model="description"
                      placeholder
                      rows="3"
                      max-rows="6"
                    ></b-form-textarea>
                    <!-- <template slot="description" v-if="validation.firstError('lastknown')">
                        <span style="color:red;">{{validation.firstError('lastknown')}}</span>
                    </template>-->
                  </b-form-group>
                  <!-- </div> -->
                </b-col>

                <b-col cols="12" md="6">
                  <!-- <div :class="{error: validation.hasError('cname')}"> -->
                  <b-form-group label="Mammal Status">
                    <b-form-input
                      v-model="mstatus"
                      id="mstatus"
                      placeholder="Mammal Status"
                    ></b-form-input>
                    <!-- <template slot="description" v-if="validation.firstError('cname')">
                        <span style="color:red;">{{validation.firstError('cname')}}</span>
                    </template>-->
                  </b-form-group>
                  <!-- </div> -->
                </b-col>
                <b-col cols="12" md="6">
                  <!-- <div :class="{error: validation.hasError('cemail')}"> -->
                  <b-form-group label="Social Unit">
                    <b-form-input
                      v-model="socialunit"
                      id="socialunit"
                      placeholder="Social Unit"
                    ></b-form-input>
                    <!-- <template slot="description" v-if="validation.firstError('cemail')">
                        <span style="color:red;">{{validation.firstError('cemail')}}</span>
                    </template>-->
                  </b-form-group>
                  <!-- </div> -->
                </b-col>
                <b-col cols="12" md="6">
                  <!-- <div :class="{error: validation.hasError('cphone')}"> -->
                  <b-form-group label="Size">
                    <b-form-input
                      v-model="size"
                      id="size"
                      placeholder="Size"
                    ></b-form-input>
                    <!-- <template slot="description" v-if="validation.firstError('cphone')">
                        <span style="color:red;">{{validation.firstError('cphone')}}</span>
                    </template>-->
                  </b-form-group>
                  <!-- </div> -->
                </b-col>
                <b-col cols="12" md="6">
                  <!-- <div :class="{error: validation.hasError('cagency')}"> -->
                  <b-form-group label="Behavoiur">
                    <b-form-input
                      v-model="behavoiur"
                      id="behavoiur"
                      placeholder="Behavoiur"
                    ></b-form-input>
                    <!-- <template slot="description" v-if="validation.firstError('cagency')">
                        <span style="color:red;">{{validation.firstError('cagency')}}</span>
                    </template>-->
                  </b-form-group>
                  <!-- </div> -->
                </b-col>
                <b-col cols="12" md="6">
                  <!-- <div :class="{error: validation.hasError('cagency')}"> -->
                  <b-form-group label="States">
                    <!-- <b-form-input
                      v-model="distribution"
                      id="distribution"
                      placeholder="Distribution"
                    ></b-form-input> -->
                    <b-form-select
                      multiple
                      :select-size="4"
                      v-model="selected"
                      :options="states"
                      value-field="_id"
                      text-field="name"
                      class="mb-3"
                    >
                    </b-form-select>
                    <!-- <div>Selected: <strong>{{ selected }}</strong></div> -->
                    <!-- <template slot="description" v-if="validation.firstError('cagency')">
                        <span style="color:red;">{{validation.firstError('cagency')}}</span>
                    </template>-->
                  </b-form-group>
                  <!-- </div> -->
                </b-col>
                <b-col cols="12" md="6">
                  <!-- <div :class="{error: validation.hasError('cagency')}"> -->
                  <b-form-group label="Distribution">
                    <b-form-input
                      v-model="distribution"
                      id="distribution"
                      placeholder="Distribution"
                    ></b-form-input>
                    <!-- <b-form-select multiple :select-size="4" v-model="selected" :options="states" value-field="_id"
      text-field="name" class="mb-3">
    </b-form-select> -->
                    <!-- <div>Selected: <strong>{{ selected }}</strong></div> -->
                    <!-- <template slot="description" v-if="validation.firstError('cagency')">
                        <span style="color:red;">{{validation.firstError('cagency')}}</span>
                    </template>-->
                  </b-form-group>
                  <!-- </div> -->
                </b-col>
                <b-col cols="12" md="6">
                  <!-- <div :class="{error: validation.hasError('cagency')}"> -->
                  <b-form-group label="Habitat">
                    <b-form-input
                      v-model="habitat"
                      id="habitat"
                      placeholder="Habitat"
                    ></b-form-input>
                    <!-- <template slot="description" v-if="validation.firstError('cagency')">
                        <span style="color:red;">{{validation.firstError('cagency')}}</span>
                    </template>-->
                  </b-form-group>
                  <!-- </div> -->
                </b-col>
                <b-col cols="12" md="6"></b-col>
              </b-row>
            </b-col>
          </b-row>
          <b-row class="py-2 justify-content-md-center text-center">
            <b-col cols="8">
              <b-row>
                <b-col md="3" v-for="(item, i) in urls" :key="i">
                  <b-row>
                    <b-col md="3" style="padding-top: 17px">
                      <img
                        :src="item"
                        class="role active"
                        style="width: 100px; height: 100px"
                      />
                    </b-col>
                    <b-col md="9">
                      <!-- <b-icon icon="fa fa-window-close" @click=" imgremove(i)"></b-icon> -->
                      <i
                        class="fa fa-window-close"
                        aria-hidden="true"
                        @click="imgremove(i)"
                      ></i>
                    </b-col>
                  </b-row>
                </b-col>
              </b-row>
            </b-col>
          </b-row>
          <b-row class="py-2 justify-content-md-center">
            <b-col cols="12" md="6">
              <b-form-group label="Mammal Images">
                <b-form-file
                  v-model="mammalimage"
                  accept="image/png, image/jpeg, image/jpg"
                  placeholder="Select a file"
                  multiple
                  @change="showImage"
                ></b-form-file>
              </b-form-group>
            </b-col>
          </b-row>
          <b-row class="py-2 justify-content-md-center">
            <span style="color: red">{{ msg }}</span>
          </b-row>
          <b-row class="justify-content-center">
            <div class="px-2">
              <b-button
                variant="outline-primary"
                size="sm"
                @click.prevent="inputCheck"
                >Submit</b-button
              >
            </div>
          </b-row>
          <template slot="footer">
            <b-button @click="$router.go(-1)" size="sm">Back</b-button>
          </template>
        </b-card>
      </b-col>
    </b-row>
  </div>
</template>
<script>
export default {
  data() {
    return {
      ServerError: false,
      appLoading: false,
      user: null,
      msg: null,
      mammalId: null,
      commonname: null,
      commonnames: [],
      family: null,
      latinname: null,
      localname: null,
      description: null,
      mammalimage: null,
      newImage: null,
      mstatus: null,
      socialunit: null,
      size: null,
      behavoiur: null,
      habitat: null,
      urls: [],
      states: [],

      distribution: null,
      formData: new FormData(),
      selected: [],
      options: [
        { value: "a", text: "This is First selected option" },
        { value: "b", text: "Default Selected Option" },
        { value: "c", text: "This is another option" },
        { value: "d", text: "This one is disabled", disabled: true },
        { value: "e", text: "This is option e" },
        { value: "f", text: "This is option f" },
        { value: "g", text: "This is option g" },
      ],
    };
  },

  beforeMount() {
    this.getStates();
  },

  methods: {
    inputCheck() {
      // this.msg = null;
      //   if (!this.commonname)
      // this.msg = "Please Provide required Fields";
      //   else
      this.addMammal();
    },
    imgremove(index) {
      this.urls.splice(index, 1);
    },
    getStates() {
      this.appLoading = true;
      axios({
        method: "GET",
        url: "/user/statelist",
        // params: {
        //   id: this.$route.params.id
        // },
        headers: {
          "x-auth-token": localStorage.getItem("token"),
        },
      })
        .then((response) => {
          this.appLoading = false;
          this.states = response.data.data;
        })
        .catch((e) => {
          this.appLoading = false;
          this.ServerError = true;
        });
    },
    addMammal() {
      this.appLoading = true;
      var suspect = {};
      suspect["commonname"] = this.commonname;
      suspect["family"] = this.family;
      suspect["latinname"] = this.latinname;
      suspect["localname"] = this.localname;
      suspect["description"] = this.description;
      suspect["mammalstatus"] = this.mstatus;
      suspect["socialunit"] = this.socialunit;
      suspect["size"] = this.size;
      suspect["behaviour"] = this.behavoiur;
      suspect["distribution"] = this.distribution;
      suspect["habitat"] = this.habitat;
      suspect["states"] = this.selected;
      axios({
        method: "POST",
        url: "/mammal/add",
        headers: {
          "x-auth-token": localStorage.getItem("token"),
        },
        data: suspect,
      })
        .then((response) => {
          this.appLoading = false;
          if (response.data.status) {
            this.mammalId = response.data.data._id;
            if (this.urls.length > 0) this.uploadmammalImage();
            else this.$router.push("/Mammals/" + this.mammalId);
          } else {
            this.msg = "Please fill the details!";
          }
        })
        .catch((err) => {
          this.appLoading = false;
          this.ServerError = true;
        });
    },
    showImage(event) {
      var selectedFiles = event.target.files[0];
      //   this.productPictures.append("photos", this.selectedFiles);
      var img;
      img = new Image();
      img.src = window.URL.createObjectURL(event.target.files[0]);
      img.onload = () => {
        if (
          selectedFiles.size < 5242880 &&
          img.width <= 500 &&
          img.height <= 500
        ) {
          const urls = URL.createObjectURL(selectedFiles);
          if (this.urls.length < 4) {
            this.urls.push(urls);
            // this.images.push(selectedFiles)
            this.formData.append("photos", selectedFiles);
          } else {
            this.msg = "Four Images Already Added!";
          }
        } else {
          this.msg =
            "File size Should be less than 5MB and width & height less than 500";
          return;
        }
      };
    },
    uploadmammalImage() {
      var vm = this;

      this.appLoading = true;

      this.formData.append("id", this.mammalId);
      axios({
        method: "POST",
        url: "/mammal/photomultiple",
        headers: {
          "Content-Type": "multipart/form-data",
          "x-auth-token": localStorage.getItem("token"),
        },
        data: this.formData,
        onUploadProgress: function (progressEvent) {
          var percentCompleted = Math.round(
            (progressEvent.loaded * 100) / progressEvent.total
          );
          vm.uploadMsg = "Uploading " + percentCompleted + "%";
          // if (percentCompleted == 100) vm.uploadMsg = "";
        },
      })
        .then((response) => {
          this.appLoading = false;
          this.$router.push("/Mammals/" + this.mammalId);
        })
        .catch((err) => {
          this.ServerError = true;
        });
    },
  },
};
</script>
